class VirtualTryOn extends HHBaseElement {
  constructor() {
    super()
    this.isReady = false
    this._isOpen = false
    this.mainProduct = this.closest('main-product')
    this._handleMakeupApplied = this._handleMakeupApplied.bind(this)
    this._handleClick = this._handleClick.bind(this)
    this._handleEngineClosed = this._handleEngineClosed.bind(this)
    this._applyMakeupFilter = this._applyMakeupFilter.bind(this)
    this._handleOpened = this._handleOpened.bind(this)
    this._handleClosed = this._handleClosed.bind(this)
    this._handleSelectedVariantChange =
      this._handleSelectedVariantChange.bind(this)

    if (document.querySelectorAll('virtual-try-on').length > 1) {
      throw new Error('Only one virtual-try-on component can be used per page')
    }
    this.$product = this.closest('.single-product')
    this.variantSelector = this.$product.querySelector('product-variants')
    this.$button = this.querySelector('button')

    this.$productGallery = this.$product.querySelector(
      '.js-product-media-container swiper-product-gallery'
    )
    this.mql = window.matchMedia('(min-width: 992px)')

    this._injectTarget()
    this._initScript()
  }

  get isOpen() {
    return this._isOpen
  }

  set isOpen(value) {
    this._isOpen = value
    this.target.classList.toggle('open', value)
    this.mainProduct.classList.toggle('vto-enabled', value)
  }

  get apiKey() {
    return this.getAttribute('api-key')
  }

  get widgetId() {
    return this.getAttribute('widget-id')
  }

  get language() {
    return this.getAttribute('language')
  }

  get privacyPolicyURL() {
    return this.getAttribute('privacy-policy')
  }

  get productUrl() {
    return this.getAttribute('data-url')
  }

  get enableEmailSharing() {
    return this.getAttribute('enable-email-sharing') === 'true'
  }

  get productData() {
    return this.mainProduct.product
  }

  get selectedVariantSKU() {
    const matchingVariant =
      this.productData.variants.length > 1
        ? this.productData.variants.find(
            (variant) =>
              String(variant.id) === String(this.variantSelector?.variantId)
          )
        : this.productData.variants[0]

    return matchingVariant ? matchingVariant.sku : null
  }

  _handleMakeupApplied(success) {}

  _injectTarget() {
    this.target = document.createElement('div')
    this.target.id = 'YMK-module'
    this.target.setAttribute(
      'class',
      'ymk-module background-color-white grid jcc'
    )
  }

  _initScript() {
    if (document.getElementById('ymk-script')) {
      this._initWidget()
    } else {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.id = 'ymk-script'
      window.ymkAsyncInit = () => {
        this._initWidget()
      }
      script.src = `https://plugins-media.makeupar.com/${this.widgetId}/sdk.js?apiKey=${this.apiKey}`
      document.body.appendChild(script)
    }
  }

  _initWidget() {
    this.isReady = true
    YMK.addEventListener('loaded', this._applyMakeupFilter)
    YMK.addEventListener('opened', this._handleOpened)
    YMK.addEventListener('engineClosed', this._handleEngineClosed)
    YMK.addEventListener('closed', this._handleClosed)

    let params = {
      autoOpen: false,
      language: this.language,
      privacyPolicyURL: this.privacyPolicyURL,
      height: Math.min(this.target.clientHeight, 600),
      width: Math.min(this.target.clientWidth, 600),
      emailType: 'production',
      enableEmailSharing: this.enableEmailSharing,
      offsetMenuY: 25,
    }
    YMK.init(params)

    if (location.hash === '#virtual-try-on') {
      this.show()
    }
  }

  _handleOpened(e) {
    this.isOpen = true
    this.target.scrollIntoView({ behavior: 'smooth' })
  }

  _handleEngineClosed() {
    this.isOpen = false
    YMK.close()
  }

  _handleClosed() {
    this.target.classList.remove('open')
    this.mainProduct.classList.remove('vto-enabled')
    this.$productGallery.querySelector(
      '.product-gallery__main'
    ).style.opacity = 1
    this.isOpen = false
  }

  _applyMakeupFilter() {
    if (!this.isReady) return
    this.mainProduct.classList.add('vto-enabled')

    YMK.applyMakeupBySku(this.selectedVariantSKU, this._handleMakeupApplied)
  }

  _handleMediaQuery() {
    if (this.target.parentNode) {
      this.target.parentNode.removeChild(this.target)
    }
    this.target.innerHTML = ''
    this.$productGallery?.appendChild(this.target)
  }

  _handleClick() {
    if (!!this.selectedVariantSKU) {
      this.mainProduct.classList.add('vto-enabled')
      this.show()
      this.$productGallery.focus()
    } else {
      console.log('Failed to Find SKU')
      throw new Error('Failed to Find SKU')
    }
  }

  _handleSelectedVariantChange() {
    if (!!this.selectedVariantSKU) {
      this._applyMakeupFilter()
      this.$button?.removeAttribute('disabled')
    } else {
      if (this.$button) this.$button.disabled = 'true'

      if (this.isOpen) {
        this.close()
      }
    }
  }

  _resetWidget() {
    YMK.removeEventListener('loaded', this._applyMakeupFilter)
    YMK.removeEventListener('loaded', this._handleOpened)
    YMK.removeEventListener('opened', this._handleOpened)
    YMK.removeEventListener('engineClosed', this._handleEngineClosed)
    YMK.removeEventListener('closed', this._handleClosed)
    this.isOpen = false
    this._initWidget()
  }

  _attachListeners() {
    this._handleMediaQuery()
    this.mql.onchange = () => {
      this._handleMediaQuery()
      if (this.isReady) {
        this._resetWidget()
      }
    }

    this.$button.addEventListener('click', this._handleClick)
    this._handleSelectedVariantChange()
  }

  _removeListeners() {
    this.mql.onchange = null
    this.$button.removeEventListener('click', this._handleClick)
    this._resetWidget()
  }

  close() {
    this.target.classList.remove('open')
    this.mainProduct.classList.remove('vto-enabled')
    YMK.closeEngine()
  }

  show() {
    this.target.classList.add('open')
    this.$productGallery.querySelector(
      '.product-gallery__main'
    ).style.opacity = 0
    if (this.isOpen) {
      this._applyMakeupFilter()
    } else {
      YMK.open(true)
    }
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  async connectedCallback() {
    if (this.variantSelector) {
      await this.variantSelector.isReadyPromise
    }
    this._attachListeners()
  }
}

window.customElements.define('virtual-try-on', VirtualTryOn)
